<template lang="pug">
.outstanding-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='รายการค้างชำระ'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          :displayDatePicker="false"
        )

      .d-flex.align-items-end.px-4.py-2
        div
          .text-15 ยอดค้างชำระ
          template(v-if='customer.account && customer.account.outstanding_balance')
            .text-21.text-bold.red
              | {{ customer.account.outstanding_balance | currency }}
        CustomSearchBox.ml-auto(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
          :isLoading='isLoading'
        )
          i.fa.fa-search

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.flex-fill
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          @itemClicked='showModal'
        )

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    SellRecordDetail(
      v-if='selectedItem'
      :customer='customer'
      :sellRecord='selectedItem.order'
      @closeButtonClicked='hideModal'
    )
</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    customer() {
      this.loadData();
    },

    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     (!KEYWORD
      //       || item.entryNo.toString().includes(KEYWORD)
      //     )
      //     // && (!this.filterStatus || item.status === this.filterStatus)
      //     && (this.filterDate === '' || this.$dateUtils.isInRange(item.dueDate, this.filterDate))
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      filterDate: '',
      filterSearch: '',
      // filterStatus: undefined,
      tableData: [],
      tableColumns: {
        dueDate: {
          title: 'กำหนดจ่าย',
          align: 'left',
          type: Date,
        },
        combinedId: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
        },
        daysPastDue: {
          title: 'วันที่เกิน',
          align: 'right',
          computed: row => ((parseInt(row.daysPastDue, 10) < 0) ? 0 : row.daysPastDue),
        },
        sellDate: {
          title: 'วันที่ทำรายการ',
          align: 'center',
          type: Date,
        },
      },

      // pagination
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.customer.history.unpaid(this.customer.id);
      // load data
      try {
        const res = await this.$api.billing.outstandings(
          this.customer.id,
          this.currentPage,
          this.filterSearch,
        );

        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,

    SellRecordDetail,
  },
};
</script>

<style lang="scss">
.outstanding-list {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
